import React, { Fragment } from 'react';
import styles from './UIGameHelpCostsInformation.module.scss';
import { getCostInformation, getPieceIconPath } from './UIGameCostsInformation.ts';
import { T } from '@colonist/ui';
import { UIGameCard } from '../../../../common/UIGameCard/index.ts';
export const UIGameHelpCostsInformation = ({ gameMode, playerColor })=>{
    const costInformation = getCostInformation(gameMode);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.uiGameInfoContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.description
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.buildCosts.description'
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.itemRow
    }, costInformation.map((item)=>/*#__PURE__*/ React.createElement(Fragment, {
            key: item.piece
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.itemTitle
        }, /*#__PURE__*/ React.createElement("img", {
            className: styles.icon,
            src: getPieceIconPath(item.piece, playerColor)
        }), /*#__PURE__*/ React.createElement("div", {
            className: styles.title
        }, /*#__PURE__*/ React.createElement(T, {
            id: item.title
        }))), /*#__PURE__*/ React.createElement("div", {
            className: styles.costContainer
        }, item.cost.map((card, index)=>/*#__PURE__*/ React.createElement(UIGameCard, {
                cardEnum: card,
                size: "xxxs",
                key: `${card}-${index}`
            })))))));
};
